var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('item-despesa',{attrs:{"item":_vm.item}},[_c('template',{slot:"footer"},[_c('app-btn-voltar',{attrs:{"rota":"DespesasGerais_Financeiro_Despesas_Detalhar"}})],1)],2),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }